import flatpickr from 'flatpickr'

function ResetDatePicker(_pluginConfig) {
  let element;

  return function instance(pickr) {
    if (pickr.config.noCalendar || pickr.isMobile) {
      return {}
    }

    return {
      onReady() {
        element = pickr._createElement('button', 'ButtonTransparent u-Pointer', 'Clear')
        element.type = 'button'
        element.tabIndex = -1
        element.addEventListener('click', () => {
          pickr.clear()
          pickr.close()
        })

        pickr.calendarContainer.appendChild(element)
        pickr.loadedPlugins.push('ResetDatePicker')
      },
    }
  }
}

// eslint-disable-next-line complexity
function init(element) {
  const input = element.querySelector('[data-input]')
  const defaultDate = input ? input.value : null

  return flatpickr(element, {
    wrap: true,
    altInput: true,
    altFormat: 'm/d/Y',
    dateFormat: element.dataset.dateFormat || 'Y-m-d',
    defaultDate: defaultDate || null,
    plugins: [new ResetDatePicker()],
    disableMobile: 'true',
  })
}

const DatePicker = {
  mounted() {
    this.pickr = init(this.el)
  },
  updated() {
    const altFormat = this.el.dataset.dateAltFormat
    const wasFormat = this.pickr.config.altFormat

    if (altFormat !== wasFormat) {
      this.pickr.destroy()
      this.pickr = init(this.el)
    }
  },
  destroyed() {
    this.pickr.destroy()
  },
}

export default DatePicker
